var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.$store.getters.showContent)?_c('div',{staticClass:"container d-flex flex-column justify-content-start mt-5"},[_c('span',{staticClass:"text-center h5"},[_vm._v("Письмо с инструкциями для восстановления пароля было отправлено на "+_vm._s(_vm.$route.params.email)+".")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }